export default __webpack_public_path__ + "static/customer-bookings-feature-165d2262afaf472a32f59bf54b1c270e.svg";